module.exports = __webpack_public_path__ + "static/lageplan_large-83a8e219f52c1b7b2c9a77fc98eb0026.png";